
import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-support-ticket',
  templateUrl: '../templates/template1/views/support-ticket.component.html',
  styleUrls: ['../templates/template1/themes/support-ticket.component.less'],
  providers: []
})
export class SupportTicketComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
